module.exports = __webpack_public_path__ + "static/media/garaio-logo.119c84c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/garaio-logo.png
// module id = 540
// module chunks = 0